module.exports = __webpack_public_path__ + "media/images/payments/mastercard-dark-095cf7f0f3609c50ee8856a2e1308669.svg";